import React, { Component } from 'react'
import EntryButton from './EntryButton'

class Catch extends Component {
  render() {
    let background_image_path = process.env.PUBLIC_URL + '/assets/images/building.jpg'
    return (
      <section
        id="catch"
        className="catch"
        style={{
          backgroundImage: 'url(' + background_image_path + ')'
        }}
      >
        <div className="container">
          <h1>
            早期内定につながる
            <br/>
            5社マッチングイベント
            <br/>
            <span className="name">{`${this.props.grad_year}`}卒「Premium Startup Seminar」</span>
          </h1>
          <p>業界研究・面接対策もできる</p>
          <div className="btn-wrapper">
            <EntryButton id={this.props.id} />
          </div>
        </div>
      </section>
    )
  }
}

export default Catch